import React from "react";
import joinMovementLogo from "../assets/join_movement.svg";
import { ReactComponent as Underline } from "../assets/underline.svg";
import { useI18n } from "../i18n/I18nProvider";

export default function JoinMovement() {
  const { t } = useI18n();

  return (
    <section className="py-12 sm:py-24 lg:py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="relative rounded-[32px] sm:rounded-[40px] p-6 sm:p-8 md:p-10 lg:p-12 xl:p-16 overflow-hidden bg-ekatraOrange">
          {/* Right-side white semicircle cut-out - matching screenshot */}
          <div
            className="
          absolute
          hidden sm:block
          lg:top-[150px] top-[140px] -translate-y-1/2
          lg:right-[-200px] right-[-220px]
          w-[400px] lg:h-[200px]
          sm:h-[170px]
          rounded-full
          bg-white
          pointer-events-none
        "
          />

          {/* Circular Logo - Top Right, positioned on the curve */}
          <div className="absolute right-4 sm:top-16 top-4 z-20">
            <div className="w-24 h-24 sm:w-36 sm:h-36 lg:w-40 lg:h-40 rounded-full bg-white flex items-center justify-center shadow-lg p-2 border-4 border-[#FDF7EF]">
              <img
                src={joinMovementLogo}
                alt="Ekatra Logo"
                className="w-full h-full object-contain"
              />
            </div>
          </div>

          {/* Content Container */}
          <div className="relative z-10 max-w-3xl">
            {/* Main Heading */}
            <div className="mb-6 sm:mb-8 pr-20 sm:pr-24">
              <h2 className="font-lexend text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-normal text-[#033049] leading-tight">
                {t("joinMovement.heading.line1")}
              </h2>
              <h2 className="font-lexend text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-[#033049] leading-tight mt-1">
                {t("joinMovement.heading.line2")}
              </h2>
              {/* Underline Decoration */}
              <div className="mt-3 sm:mt-4">
                <Underline className="w-[220px] sm:w-[280px] md:w-[320px] lg:w-[420px] relative -top-4" />
                {/* SPARKS */}
              {/* <svg
                className="relative -top-28 sm:-top-32 md:-top-36 xl:-top-40 ml-auto translate-x-[-180px]"
                width="74"
                height="68"
                viewBox="0 0 74 68"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.1737 11.5L5.00122 42M68.1737 5L21.6737 49.5M37.6737 62.5L68.1737 49.5"
                  stroke="white"
                  strokeWidth="10"
                  strokeLinecap="round"
                />
              </svg> */}
              </div>
            </div>

            {/* Subheading */}
            <h3 className="font-lexend text-lg sm:text-xl lg:text-2xl font-bold text-[#033049] mb-4 sm:mb-6">
              {t("joinMovement.subheading")}
            </h3>

            {/* Description */}
            <p className="font-lexend text-sm sm:text-base lg:text-lg text-[#033049] leading-relaxed mb-6 sm:mb-8">
              {t("joinMovement.description")}
            </p>

            {/* Bullet Points */}
            <ul className="space-y-3 sm:space-y-4 font-lexend text-sm sm:text-base lg:text-lg text-[#033049]">
              <li className="flex items-start gap-2">
                <span className="text-[#033049] mt-1 flex-shrink-0">&gt;</span>
                <span>
                  <strong className="font-bold">
                    {t("joinMovement.bullets.students.title")}
                  </strong>{" "}
                  {t("joinMovement.bullets.students.description")}
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#033049] mt-1 flex-shrink-0">&gt;</span>
                <span>
                  <strong className="font-bold">
                    {t("joinMovement.bullets.educators.title")}
                  </strong>{" "}
                  {t("joinMovement.bullets.educators.description")}
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#033049] mt-1 flex-shrink-0">&gt;</span>
                <span>
                  <strong className="font-bold">
                    {t("joinMovement.bullets.institutions.title")}
                  </strong>{" "}
                  {t("joinMovement.bullets.institutions.description")}
                </span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#033049] mt-1 flex-shrink-0">&gt;</span>
                <span>
                  <strong className="font-bold">
                    {t("joinMovement.bullets.lifelong.title")}
                  </strong>{" "}
                  {t("joinMovement.bullets.lifelong.description")}
                </span>
              </li>
            </ul>
            <p className="font-lexend text-sm sm:text-base lg:text-lg text-[#033049] leading-relaxed mt-6 sm:mt-8">
              {t("joinMovement.description_2")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
